module.exports = __webpack_public_path__ + "static/media/magnifier_icon.2ea81818.svg";